const rankingItems = [
  { rank: 1, name: '香蕉视频', desc: '海量高清影视资源，每日更新热门大片', tag: '最热', tagColor: 'bg-primary-100 text-primary-700' },
  { rank: 2, name: '红桃视频', desc: '独家自制内容，精选综艺与纪录片', tag: '推荐', tagColor: 'bg-accent-100 text-accent-800' },
  { rank: 3, name: '91视频', desc: '用户原创社区，多元化短视频内容', tag: '热门', tagColor: 'bg-primary-100 text-primary-700' },
  { rank: 4, name: '蜜桃视频', desc: '海量影视剧集，支持高清流畅播放', tag: '新晋', tagColor: 'bg-secondary-100 text-secondary-800' },
  { rank: 5, name: '西瓜视频', desc: '个性化推荐算法，发现你的专属内容', tag: '优质', tagColor: 'bg-secondary-100 text-secondary-800' },
  { rank: 6, name: '樱花视频', desc: '日韩影视专区，字幕组精译作品', tag: '精品', tagColor: 'bg-accent-100 text-accent-800' },
  { rank: 7, name: '糖豆视频', desc: '轻量化短视频，娱乐消遣首选', tag: '人气', tagColor: 'bg-primary-100 text-primary-700' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门排行</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            根据用户访问热度与内容更新频率综合排名的在线视频平台榜单
          </p>
        </div>
        <div className="space-y-3">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 md:gap-5 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-background-100/50 transition-all group cursor-pointer"
            >
              <div className={`w-8 h-8 md:w-10 md:h-10 flex-shrink-0 rounded-lg flex items-center justify-center font-heading font-bold text-sm md:text-base ${
                i < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.name}
                  </h3>
                  <span className={`text-xs px-2 py-0.5 rounded-full whitespace-nowrap ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 mt-1 line-clamp-1">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity hidden md:block">
                <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium whitespace-nowrap">
                  查看详情 <i className="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}